import { grey } from "@mui/material/colors";
import { HOME_BODY_COLOR } from "styles/oneOffColor";

const styles = {
  card: {
    p: 1,
    border: `1px solid ${grey[200]}`,
    borderRadius: 4,
  },
  planTitleCard: {
    pt: 1.5,
    pb: 3,
    pr: 1.5,
    pl: 3,
    borderRadius: 4,
    mb: 3,
  },
  iconBlock: {
    fontSize: 20,
    backgroundColor: HOME_BODY_COLOR,
    borderRadius: 2,
    width: 35,
    height: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    p: 1,
    mr: 3,
  },
  strike: {
    textDecoration: "line-through",
    color: "#7a9f9c",
    fontSize: 22,
  },
  price: {
    display: "flex",
    gap: 1,
    color: "white",
    fontSize: 25,
    alignItems: "center",
  },
  link: {
    fontSize: 13,
    color: "white",
    textDecoration: "underline",
    textDecorationColor: "#7a9f9c",
  },
  chipVa: {
    backgroundColor: "white",
    px: 1,
  },
  discount: {},
};

export default styles;
